import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faPen } from '@fortawesome/pro-light-svg-icons';

export type ProLightPenProps = IconComponentProps;

export const ProLightPen = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightPenProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faPen}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faPen}
    />
  );
};

ProLightPen.displayName = 'ProLightPen';
